import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.340 8.277 C 4.162 8.320,4.065 8.381,3.927 8.538 C 3.719 8.776,3.705 9.159,3.896 9.433 C 3.952 9.514,5.695 11.276,7.769 13.348 C 10.419 15.997,11.584 17.135,11.689 17.178 C 11.771 17.212,11.911 17.240,12.000 17.240 C 12.089 17.240,12.229 17.212,12.311 17.178 C 12.416 17.135,13.581 15.997,16.231 13.348 C 18.305 11.276,20.048 9.514,20.104 9.433 C 20.363 9.061,20.232 8.543,19.825 8.332 C 19.662 8.248,19.333 8.251,19.159 8.338 C 19.083 8.377,17.441 9.986,15.510 11.914 L 12.000 15.419 8.490 11.914 C 6.560 9.986,4.926 8.382,4.860 8.350 C 4.701 8.271,4.488 8.242,4.340 8.277 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgCaretDown;
